export default function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1">
            <span className="inline-block px-3 py-1 rounded-full bg-primary-100/80 text-primary-700 text-xs font-medium mb-4">
              关于我们
            </span>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-6">关于43423漫画网</h2>

            <div className="space-y-4 text-sm md:text-base text-foreground-700 leading-relaxed">
              <p>
                <strong className="text-foreground-900">43423漫画网</strong> 是一个专注于下拉式漫画在线阅读的平台，致力于为广大漫画爱好者提供最流畅、最舒适的下拉式阅读体验。
                我们汇聚了海量优质的韩漫下拉式、日漫下拉式以及国产漫画资源，覆盖恋爱、热血、悬疑、奇幻等多元题材。
              </p>
              <p>
                平台采用独特的上下滑动浏览模式，彻底告别传统翻页阅读的繁琐操作。无论你是在手机上、平板上还是电脑前，
                只需轻轻滑动，就能沉浸式地享受漫画的精彩世界。每日更新的热门连载，让你永远走在追更的最前线。
              </p>
              <p>
                我们深知每一位漫画爱好者的需求——快速加载、高清画质、绿色无广告的纯净阅读环境。
                43423漫画网持续优化产品体验，让下拉式漫画阅读成为一种享受。欢迎加入我们，与千万漫友一起畅游漫画世界。
              </p>
            </div>

            <div className="flex flex-wrap gap-3 mt-6">
              <div className="px-4 py-2 rounded-full bg-primary-100 text-primary-700 text-xs font-medium">韩漫大全</div>
              <div className="px-4 py-2 rounded-full bg-accent-100 text-accent-700 text-xs font-medium">日漫热载</div>
              <div className="px-4 py-2 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium">国产精品</div>
              <div className="px-4 py-2 rounded-full bg-primary-100 text-primary-700 text-xs font-medium">下拉式阅读</div>
              <div className="px-4 py-2 rounded-full bg-accent-100 text-accent-700 text-xs font-medium">免费看漫画</div>
            </div>
          </div>

          <div className="flex-shrink-0 w-full max-w-[420px] lg:w-[380px]">
            <div className="relative rounded-2xl overflow-hidden aspect-[4/5] bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=A%20cozy%20reading%20scene%20with%20a%20person%20happily%20scrolling%20through%20colorful%20comics%20on%20a%20tablet%2C%20surrounded%20by%20floating%20comic%20panels%20and%20speech%20bubbles%2C%20warm%20orange%20and%20cream%20color%20palette%2C%20modern%20flat%20illustration%2C%20playful%20vibe%2C%20professional%20digital%20art%2C%20clean%20composition&width=840&height=1050&seq=about-illustration-01&orientation=portrait"
                alt="43423漫画网 - 关于我们：下拉式漫画阅读平台"
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}